import React from 'react';
import * as Render from '../../platformui/Base/Render';
import ImageBlock from '../../blocks/image-block';
import LinkBlock from '../../blocks/link-list-block';
import classNames from 'classnames';

const LinkCollectionBlock = (props) => (
  <LinkBlock {...props} className={'error404-linklist'} />
);

const Blocks = {
  ImageBlock,
  LinkCollectionBlock,
};

const className = classNames([
  'c-section',
  'c-section--last',
  'error404',
  'iu-text-center',
  'iu-mx-auto',
  'iu-mt-lg',
]);

const ErrorPage404 = (props) => {
  return (
    <main id="content" className="main">
      {(props.Content.Heading || props.Content.Preamble) && (
        <section className={className}>
          <div className="c-articleheader c-articleheader--alert">
            <div className="c-articleheader__inner-container">
              <h1 className="c-articleheader__heading">
                {Render.Property(props.Content.Heading, 'Heading')}
              </h1>
              <div className="preamble">
                {Render.PropertyAsHTML(props.Content.Preamble, 'Preamble')}
              </div>
            </div>
          </div>

          <Render.Block
            blocks={props.Content.MainContent}
            propertyName="MainContent"
            currentPageProps={props}
          >
            <Render.BlockTypeRenderer Blocks={Blocks} />
          </Render.Block>
        </section>
      )}
    </main>
  );
};

export default ErrorPage404;
